import Project from "backbone/projects/models/project.js"
PROJECTS_PER_PAGE = 100

export default class ProjectsCollection extends Backbone.Collection
  model: Project

  url: -> '/portfolio/projects'

  pendingCount: ->
    _.filter(@models, (model) ->
      !(model.persisted() || model.get("createFailed"))
    ).length

  createFailedCount: ->
    _.filter(@models, (model) ->
      model.get("createFailed")
    ).length

  editingProject: ->
    @any (model) -> model.get("editMode")

  importComplete: ->
    @pendingCount() == 0

  pendingSkills: ->
    _.filter(@models, (model) ->
      !model.get("addSkillsSucceeded")
    ).length

  pendingTopics: ->
    _.filter(@models, (model) ->
      !model.get("addTopicsSucceeded")
    ).length

  noSavePending: ->
    @where({savePending: false}).length == @models.length

  saveSkillsComplete: ->
    @pendingSkills() == 0

  saveTopicsComplete: ->
    @pendingTopics() == 0

  persistedCount: ->
    _.filter(@models, (model) ->
      model.persisted()
    ).length

  refreshTotalCount: ->
    $.ajax
      url: @url()
      type: "GET"
      dataType: "json"
      success: (response) =>
        @trigger("refreshCount", totalCount: response.total_count)

  parse: (resp)->
    resp.projects

  fetchMore: ->
    $.ajax
      url: @url()
      type: "GET"
      dataType: "json"
      data:
        page: Math.floor(@size() / PROJECTS_PER_PAGE) + 1
      success: (response) =>
        for project in response.projects
          @add(project, { silent: true })
        hasNextPage = response.total_count > @size()
        @trigger("render", hasNextPage: hasNextPage, totalCount: response.total_count)




// WEBPACK FOOTER //
// ./app/javascript/backbone/projects/collections/projects_collection.js.coffee